const moment = require('moment-timezone');
const time = moment();

// Global Array for Mapping
const DAYSMAPPING = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
};

const calculateNextSendTime = (reminder, frequency, day) => {
    const now = time;
    const todaysDay = time.format('d');
    const [hours, minutes] = reminder.split(':').map(Number);
    let nextSend = moment([time.get('year'), time.month(), time.date(), hours, minutes, 0]);
    if (frequency === 'Daily') {
        if (nextSend.isBefore(now)) {
            nextSend = moment([time.get('year'), time.month(), time.date(), hours, minutes, 0]).add(24, 'hours');
        } else {
            nextSend = moment([time.get('year'), time.month(), time.date(), hours, minutes, 0]);
        }
    } else {
        const reminderDayNum = DAYSMAPPING[day];
        const dayDiff = reminderDayNum - todaysDay;
        const offset = (dayDiff < 0) ? 7 + dayDiff : dayDiff;
        if (nextSend.isBefore(now)) {
            nextSend = moment([time.get('year'), time.month(), time.date(), hours, minutes, 0]).add(offset, 'day');
        } else {
            nextSend = moment([time.get('year'), time.month(), time.date(), hours, minutes, 0]).add(offset, 'day');
        }
    }
    const daysLeft = nextSend.diff(now, 'days');
    const minutesLeft = nextSend.diff(now, 'minutes') % 60;
    const hoursLeft = nextSend.diff(now, 'hours') % 24;
    const reminderTime = [daysLeft, hoursLeft, minutesLeft];
    return reminderTime;
};

export { time, moment, calculateNextSendTime };
